<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading">
	<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-container *ngIf="!loading">
	<div class="row mx-0 align-items-center mt-2 mb-1">
		<div class="col-auto px-0">
			<button mat-button class="back-btn fg-purple d-inline-flex align-items-center" (click)="onBack()">
				<mat-icon class="me-1 back-icon">arrow_back</mat-icon>
				<span>{{ locale.translations['payment']['n622'] }}</span>
			</button>
		</div>
		<div class="col"></div>
		<div class="col-auto cursor-pointer d-flex align-items-center" (click)="onOpenWhatsapp()">
			<img [src]="'/assets/images/payment/whatsapp.svg' | s3Image" class="img-responsive wh-18px" [ngClass]="{ 'me-2': locale.lang === 'en', 'ms-2': locale.lang !== 'en' }" />
			<span class="help fg-purple">{{ locale.translations['whats-new']['new-auth']['n572'] || 'Call for help' }}</span>
		</div>
	</div>

	<div class="row mx-0 justify-content-between mb-5">
		<div class="col-12 px-0">
			<span class="d-block fs-24px fw-500 fg-purple">{{ locale.translations['payment']['n698'] }}</span>
			<span class="d-block fg-grey mt-2">{{ locale.translations['payment']['n699'] }}</span>
		</div>
	</div>

	<!-- Upgrade banner -->
	<div class="upgrade-banner my-5 d-flex flex-column justify-content-center align-items-center">
		<div class="banner-title text-center fw-500 lh-24px fs-20px">{{ locale.translations['payment']['n700'] }}</div>
		<div class="banner-subtitle text-center fw-400 fs-14px">{{ locale.translations['payment']['n701'] }}</div>
	</div>

	<div class="row mx-0">
		<!-- VIP PLUS -->
		<div class="col-md col-sm-12 py-5 px-3 px-lg-5 custom-border tier-card d-flex flex-column">
			<div class="card-header position-relative">
				<span class="d-block fw-500 fg-grey">{{ locale.translations['n729'] }}</span>
				<span class="badge-pill">{{ locale.translations['n729'] }}</span>
				<span class="fs-24px fg-purple fw-500 vip-price">{{ locale.translations['n704'] }}</span>
			</div>

			<ul class="list-unstyled fg-grey px-0 mb-4 mt-4">
				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular fw-500">{{ locale.translations['payment']['n702'] }}</span>
				</li>
				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n703'] }}</span>
				</li>

				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n704'] }}</span>
				</li>
				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n705'] }}</span>
				</li>
				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n706'] }}</span>
				</li>
				<li class="mb-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n707'] }}</span>
				</li>
				<li class="mb-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n708'] }}</span>
				</li>
			</ul>
			<div class="text-center" *ngIf="ad['data']?.['vipPlus'] === '0' && !this.hideButton">
				<button mat-flat-button class="fw-400 w-100 mt-2 mb-1 mt-auto" color="primary" (click)="sendWhatsappMessage()">
					<img
						[src]="'/assets/images/social/whatsapp.svg' | s3Image"
						class="img-responsive wh-18px mb-1"
						[ngClass]="{ 'me-1': locale.lang === 'en', 'ms-1': locale.lang !== 'en' }"
					/>
					{{ locale.translations['payment']['n709'] }}
				</button>
			</div>
		</div>

		<!-- VIP -->
		<div class="col-md col-sm-12 py-5 px-3 px-lg-5 custom-border tier-card d-flex flex-column mx-16px my-16px">
			<div class="card-header position-relative">
				<span class="d-block fw-500 fg-grey">{{ locale.translations['ads']['ad']['n118'] }}</span>
				<span class="badge-pill">{{ locale.translations['ads']['ad']['n118'] }}</span>
				<span class="fs-24px fg-purple fw-500 vip-price">{{ locale.translations['payment']['n223'] }}</span>
			</div>

			<ul class="list-unstyled fg-grey px-0 mb-4 mt-4">
				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular fw-500">{{ locale.translations['payment']['n710'] }}</span>
				</li>
				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n711'] }}</span>
				</li>

				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n712'] }}</span>
				</li>
				<li class="mb-sm-2 mb-md-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n713'] }}</span>
				</li>
				<li class="mb-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n714'] }}</span>
				</li>
				<li class="mb-3">
					<mat-icon class="fs-16px align-middle fg-purple" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
						check
					</mat-icon>
					<span class="text-body-14px-regular">{{ locale.translations['payment']['n715'] }}</span>
				</li>
			</ul>
			<button mat-flat-button class="fw-400 w-100 mt-2 mb-1 mt-auto" *ngIf="ad['data']?.['vipPlus'] === '0' && ad['data']?.['vip'] === '0' && !this.hideButton" (click)="onOpenBoostAdDialog('vip')" color="primary">
				{{ locale.translations['payment']['n716'] }}
			</button>

		</div>

	</div>

	<!-- Post-section note and link -->
	<div class="row mx-0 mt-4">
		<div class="col-12 text-center fg-grey">
			{{ locale.translations['payment']['n717'] }}
		</div>
	</div>
	<div class="row mx-0 mt-2">
		<div class="col-12 text-center">
			<a class="go-to-ads-link" [routerLink]="['/user/' + user?.['userID'] + '/ads']">{{ locale.translations['payment']['n718'] }}</a>
		</div>
	</div>

	<div class="row mt-4 mx-0">
		<div class="col-12 ps-1">
			<app-video-modal></app-video-modal>
		</div>
	</div>
</ng-container>
